module.exports = __webpack_public_path__ + "img/2024-07-01a_2.d3257fd8.jpg";